import LegalDocumentPage from '../components/LegalDocumentPage'
import { termsContent, TERMS_LAST_UPDATED } from '../content/termsContent'

const TermsOfService = () => (
  <LegalDocumentPage
    contentByLanguage={termsContent}
    lastUpdated={TERMS_LAST_UPDATED}
  />
)

export default TermsOfService
